// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"bd22c8aa","694":"4730a067","937":"962b3dbc"}[chunkId] + ".chunk.js";
};